<template>
  <div>
    <div class="mb-3 gd-background">
      <section><!--franchise-->
        <v-parallax src="/static/img/background-apps.png" height="550">
          <v-layout column align-start justify-start class="white--text pl-5 pt-5">
            <v-flex xs12 md12 offset-md2>
              <div class="white--text text-md-left">
                <h1 class="text-executive-lg uppercase text-shadow">
                  kopi ketjil <br> loyalty program. <br>
                  <span class="gd-blue-text"> 1 free coffee! </span> <br>
                  to be claim <br>
                </h1>
                <p class="text-courier-new-xs-white">
                  *tnc applied
                </p>
              </div>
            </v-flex>
          </v-layout>
        </v-parallax>
      </section><!--/franchise-->
      <section>
        <v-flex xs12>
          <v-container grid-list-xl class="white--text text-md-left py-5">
            <v-layout row wrap align-center justify-center>
              <v-container grid-list-xl>
                <v-layout row wrap align-center>
                  <v-flex xs12 md12>
                    <v-card color="transparent" flat>
                      <div>
                        <h3 class="headline mb-2 text-executive-lg-black uppercase bold text-sm-center mb-5">YOUR STAMPS</h3>
                        <v-layout row wrap align-start class="mb-3">
                          <v-flex xs12 md12>
                            <div class="rewards">
                              <div class="rewards__item" :class="{ 'rewards__item--stamped': i < progress }"
                                   v-for="i in 10" :key="i">
                                <div v-if="i === 10">FREE COFFEE!</div>
                                <div v-else>No. {{i }}</div>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                        <p class="text-courier-new-xs">
                          *Get 1 stamp with every coffee purchase
                        </p>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
                <hr class="mb-4">
                <section>
                  <v-parallax src="/static/img/background-blue-flat.png" height="auto">
                    <v-flex xs12>
                      <div class="rewards-gift">
                        <div class="rewards-gift__title">
                          Reward list
                        </div>
                        <div class="rewards-gift__content">
                          <img src="/static/img/logo-circle-96.png" alt="">
                          <v-flex>
                            <div class="text-courier-new-lg-white-bold">Free 1 Coffee</div>
                            <small class="text-courier-new-xs-white">Claim it for 10 stamps</small>
                          </v-flex>
                        </div>
                      </div>
                    </v-flex>
                  </v-parallax>
                </section>
              </v-container>
            </v-layout>
          </v-container>
        </v-flex>
      </section>
    </div>
    <!-- <FooterApps /> -->
  </div>
</template>

<script>
import FooterApps from '@/components/FooterApps'

export default {
  name: 'rewards',
  components: {
    FooterApps
  },
  data() {
    return {
      progress: 7
    }
  }
}
</script>

<style lang="scss" scoped>
.rewards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: white;
  padding: 32px 16px;
  border-radius: 16px;
  box-shadow: 0 0 24px -4px rgba(0, 0, 0, 0.12);

  &__item {
    display: inline-flex;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    border: 2px dashed rgba(0,0,0,0.3);
    color: black;
    font-weight: bold;
    text-align: center;

    @media screen and (max-width: 960px - 1px) {
      width: 75px;
      height: 75px;
    }

    &:last-child {
      font-size: 18px;
      font-weight: bolder;
      @media screen and (max-width: 960px - 1px) {
        font-size: 14px;
      }
      border: 3px dashed rgba(0,0,0,0.3);
    }

    &--stamped {
      background-image: url('/static/img/coffee-135.png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: 3px solid black;
      color: white;
    }
  }
}

.rewards-gift {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__title {
    font-weight: bold;
    font-size: 20px;
  }

  &__content {
    display: flex;
    flex-direction: row;
    gap: 16px;
    & > img {
      object-fit: contain;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Rewards.vue